import React, { useEffect, useState } from 'react'
import { Button } from '../../components/cta_utils/AnButton'
import { AnInputBox } from '../../components/input_utils/AnInput';
import { iss_sso_domain } from '../../components/utils/helper_utils';

const OktaLoginScreen = () => {
    const [email, setEmail] = useState("");
    const [validEmail, setValidEmail] = useState("");
    const [errors, setErrors] = useState({})
    const [isLoading, setIsloading] = useState({});
    // useEffect(() => {        
    // }, [email, setValidEmail])

    const onFormSubmit = () => {
        let errors = {}
        if(!email) {
            errors["email"] = "Enter a valid email id";            
        }
        if(email && !iss_sso_domain(email)){
            errors["button"] = "Your account does not support SSO. Redirecting to standard login...";
            setTimeout(() => window.location.href="/login", 5000)            
        }
        setErrors(errors);
        if(Object.keys(errors).length !== 0) return;
        setIsloading({redirecting: true})
        window.location.href = "https://osuf.okta.com/app/osuf_almaconnect_1/exk21n5hs5qIXMKRr0h8/sso/saml";
    }
    return (
        <React.Fragment>.          
            <div className="login_component_container">
                <div className="text_title_big" style={{textAlign: 'center'}}>
                    Login with Single Sign-On (SSO)
                </div>
                <div style={{marginTop: '24px'}}>
                    <AnInputBox label={"Email"} error={errors["email"]}>
                        <input type="text" id="email" value={email} onChange={(e) => {setErrors({}); setEmail(e.target.value)}} placeholder="johndoe@domain.com"/>
                    </AnInputBox>
                </div>
                <div className='btn_login'>
                    <Button buttonSize="Big" onClick={onFormSubmit} error={errors["button"]} disabled={!email || errors["button"]} isLoading={isLoading["redirecting"]} buttonStyle={{width: '100%'}}>
                        Continue with SSO
                    </Button>
                </div>                        
                <div className='text_body_light' style={{width: "max-content", margin: "auto", marginTop: "16px"}}>
                    Don’t have an account? Contact your admin
                </div>
            </div>
        </React.Fragment>
    );
}

export default OktaLoginScreen